'use client';

import { sendGTMEvent } from '@next/third-parties/google';

import { storeProduct, selectCountProductInCart } from '@/fo/store/product';

import {
  GTMEventAuth,
  GTMEventEcommerce,
  GTMEcommerceItem,
  GTMEventNameEcommerce,
  GTMItemListName
} from './types';

// Хранилище листов для события просмотра перед добавлением в корзину
const storeItemListName = new Map<string, GTMItemListName>();
const viewedEvents = ['detail', 'impressions'];
const FALLBACK_ITEM_LIST_NAME: GTMItemListName = 'cart';

export const sendGTMEventEcommerce = <T extends GTMEventNameEcommerce>(
  data: GTMEventEcommerce<T>
) => {
  // sendGTMEventEcommerce будет вызван, после обновления корзины
  const snapshot = storeProduct.getSnapshot();
  const isViewedEvent = viewedEvents.includes(data.event);
  const isImpressionEvent = data.event === 'impressions';

  const items: GTMEcommerceItem[] =
    data.ecommerce.products && data.ecommerce.products?.length > 0
      ? data.ecommerce.products.map((item) => {
          const cartCount = selectCountProductInCart(item.id)(snapshot);

          if (isViewedEvent && cartCount === 0) {
            // Сохраняем лист, при просмотре товара, если товара нет в корзине
            storeItemListName.set(
              item.id,
              item?.list || FALLBACK_ITEM_LIST_NAME
            );
          }

          const isRemovedItem = data.event === 'remove' && cartCount === 0;
          if (isRemovedItem) {
            // Удаляем лист, при полном удалении товара из корзины
            storeItemListName.delete(item.id);
          }

          // Берем лист из хранилища, для всех событий, кроме просмотра товара
          const listName = isViewedEvent
            ? item.list // В события просмотра всегда передается лист
            : storeItemListName.get(item.id) || FALLBACK_ITEM_LIST_NAME;
          return {
            ...item,
            ...(listName && { list: listName })
          };
        })
      : [];
  sendGTMEvent({
    ecommerce: {
      currencyCode: data.ecommerce.currency || 'RUB',
      ...(isImpressionEvent && { [data.event]: items }),
      ...(!isImpressionEvent && {
        [data.event]: {
          products: items,
          ...(data.ecommerce.revenue && { value: data.ecommerce.revenue }),
          ...(data.ecommerce.id && { id: data.ecommerce.id }),
          ...(data.ecommerce.coupon && { coupon: data.ecommerce.coupon }),
          ...(data.ecommerce.actionField && {
            actionField: data.ecommerce.actionField
          })
        }
      })
    }
  });
};

export const sendGTMEventAuth = (data: GTMEventAuth) => {
  sendGTMEvent(data);
};

export { sendGTMEvent };
